import ServerConnection from './server-connection.js';
import PeersManager from './peers-manager.js';


export default class Network {


  constructor() {
    this.server = new ServerConnection();
    this.peersManager = new PeersManager(this.server);
  }


  close() {
    this.server.close();
    this.peersManager.close();
  }
}
